import { Event, PayloadableEvent } from '../types';

export function isPayloadEvent<TFormData, TKeys extends string>(
  event: Event<TFormData, TKeys>,
): event is PayloadableEvent<TFormData> {
  return ['NEXT', 'SUBMIT'].includes(event.type);
}
